import React, { useEffect, useState } from "react";
import { HandCoins, ReceiptText } from "lucide-react";
import { Card } from "@/components/ui/card";
import { api } from "@/lib/api";

const money = (amount) => `$${Number(amount || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export default function TipEarningsCard() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/me/tip-earnings").then((response) => setData(response.data)).catch(() => setData({ linked: false }));
  }, []);

  if (!data || !data.linked) return null;
  const activity = data.activity || [];
  return (
    <Card className="mb-4 border-amber-300 bg-amber-50/50 p-5" data-testid="tip-earnings-card">
      <div className="flex items-start justify-between gap-4">
        <div>
          <p className="label-eyebrow text-amber-800">Personnel earnings</p>
          <h2 className="mt-1 flex items-center gap-2 text-lg font-bold" data-testid="tip-earnings-title"><HandCoins size={18} /> Your tips</h2>
          <p className="mt-1 text-xs text-gray-600">Tips are attributed separately from duties and commission activity.</p>
        </div>
        <div className="text-right" data-testid="tip-earnings-all-time"><p className="label-eyebrow text-amber-800">All-time tips</p><p className="text-2xl font-bold tabular-nums text-amber-900">{money(data.all_time)}</p></div>
      </div>
      <div className="mt-4 flex items-center justify-between border-y border-amber-200 py-3 text-sm" data-testid="tip-earnings-this-month"><span>This month</span><span className="font-bold tabular-nums text-amber-900">{money(data.this_month)}</span></div>
      {activity.length > 0 ? (
        <ul className="mt-3 divide-y divide-amber-100 overflow-hidden rounded-md border border-amber-100 bg-white" data-testid="tip-earnings-activity">
          {activity.map((entry) => <li key={entry.order_id} className="flex items-center justify-between gap-3 px-3 py-2 text-sm" data-testid={`tip-earnings-order-${entry.order_id}`}><span className="flex min-w-0 items-center gap-2"><ReceiptText size={13} className="shrink-0 text-amber-700" /> <span>{entry.line_item} · Order {String(entry.order_id || "").slice(0, 8)}</span></span><span className="shrink-0 font-semibold tabular-nums text-amber-900">{money(entry.amount)}</span></li>)}
        </ul>
      ) : <p className="mt-3 text-xs text-gray-500" data-testid="tip-earnings-empty">No attributed tips yet.</p>}
    </Card>
  );
}